import { HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { NotificationService } from './notification.service';
import { SeverityEnum } from '../enums/severity.enum';
import { IResultData } from '../interfaces/result-data.interface';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private translocoService = inject(TranslocoService);
  private nofificationService = inject(NotificationService);

  responseErrorHandler(status: HttpStatusCode) {
    const title = this.translocoService.translate(
      `httpResponses.${status}.title`,
    );
    const message = this.translocoService.translate(
      `httpResponses.${status}.message`,
    );
    switch (status) {
      case HttpStatusCode.BadRequest: {
        this.nofificationService.showToast(message, title, SeverityEnum.Error);
        break;
      }
      case HttpStatusCode.Unauthorized: {
        this.nofificationService.showToast(message, title, SeverityEnum.Error);
        break;
      }
      case HttpStatusCode.Forbidden: {
        this.nofificationService.showToast(message, title, SeverityEnum.Error);
        break;
      }
      case HttpStatusCode.NotFound: {
        this.nofificationService.showToast(message, title, SeverityEnum.Error);
        break;
      }
      case HttpStatusCode.InternalServerError: {
        this.nofificationService.showToast(message, title, SeverityEnum.Error);
        break;
      }
      case HttpStatusCode.NoContent: {
        this.nofificationService.showToast(message, title, SeverityEnum.Warn);
        break;
      }
      default: {
        const defaultTitle = this.translocoService.translate(
          'httpResponses.default.title',
        );
        const defaultMessage = this.translocoService.translate(
          'httpResponses.default.message',
        );

        this.nofificationService.showToast(
          defaultMessage,
          defaultTitle,
          SeverityEnum.Error,
        );
        break;
      }
    }
  }

  dataErrorHandler(resultData: IResultData) {
    const title = this.translocoService.translate(`errors.dataErrorTitle`);

    this.nofificationService.showToast(
      resultData.errorMessage as string,
      title,
      SeverityEnum.Warn,
    );
  }
}
